import { PrizeTypeEnum } from 'entities/prize';

export const fromPrizeTypeToHumanReadableText = (prizeType: PrizeTypeEnum) => {
  const mapper = {
    [PrizeTypeEnum.COUPON]: 'купон',
    [PrizeTypeEnum.PROMO]: 'промокод',
    [PrizeTypeEnum.CERTIFICATE]: 'сертификат',
  };

  return mapper[prizeType] || '';
};
